import firebase from "firebase"

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyA37mISAGO-tKbXgMdU6-4QFzBejgwr7uY",
    authDomain: "todo-app-cp-3d2cf.firebaseapp.com",
    projectId: "todo-app-cp-3d2cf",
    storageBucket: "todo-app-cp-3d2cf.appspot.com",
    messagingSenderId: "556161615260",
    appId: "1:556161615260:web:a4bf72f9e41019a920f459",
    measurementId: "G-KNBQC2QKJN"
})

const db = firebaseApp.firestore()

export default db